import { useEffect } from 'react';
import { useWarehouseStore } from '../store/warehouseStore';
import { useCartStore } from '../store/cartStore';

export const useWarehouseInitialization = () => {
  const {
    defaultWarehouse,
    selectedWarehouse,
    initializeWarehouse,
    loadAllWarehouses
  } = useWarehouseStore();

  const { updateAllItemStocks } = useCartStore();

  useEffect(() => {
    const initializeApp = async () => {
      try {
        // Инициализируем склад по умолчанию
        if (!defaultWarehouse) {
          await initializeWarehouse();
        }

        // Загружаем все склады для выбора
        await loadAllWarehouses();
      } catch (error) {
        console.error('Ошибка инициализации складов:', error);
      }
    };

    initializeApp();
  }, [defaultWarehouse, initializeWarehouse, loadAllWarehouses]);

  useEffect(() => {
    // При изменении выбранного склада обновляем остатки товаров
    if (selectedWarehouse && defaultWarehouse) {
      const updateStocks = async () => {
        try {
          await updateAllItemStocks(selectedWarehouse.id);
        } catch (error) {
          console.error('Ошибка обновления остатков:', error);
        }
      };

      updateStocks();
    }
  }, [selectedWarehouse, defaultWarehouse, updateAllItemStocks]);

  return {
    defaultWarehouse,
    selectedWarehouse,
    isLoading: !defaultWarehouse,
    isInitialized: !!defaultWarehouse
  };
};

